import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './GiftCardBanner.scss';
import useExperiment from 'hooks/useExperiment';

const GiftCardBanner = ({ className = '', content }) => {
	const { sf15309Variation } = useExperiment('sf_15309_giftcard_incentives');
	return sf15309Variation === 'variation' ? (
		<div className={classnames('gift-card-banner', className)}>
			{content}
		</div>
	) : (
		<></>
	);
};

GiftCardBanner.propTypes = {
	className: PropTypes.string,
	content: PropTypes.any,
};

export default GiftCardBanner;
